<div class="card-item">
  <address class="card-content">
    <div class="personal-info">
      @if (topline) {
        <div class="copy-s topline">{{ topline }}</div>
      }
      <div class="name h4 font-family-title">{{ fullname }}</div>
      <div class="position copy-m font-family-text">
        {{ position }}
      </div>
    </div>
    @if (email || phone) {
      <div class="contact-info">
        @if (email) {
          <div class="contact-info-item font-family-text contact-mail">
            <div class="info-label copy-s">{{ 'EMAIL' | translate }}:</div>
            <div class="info-value">
              <a class="btn btn-text" href="mailto:{{ email }}">{{ email }}</a>
            </div>
          </div>
        }
        @if (phone) {
          <div class="contact-info-item font-family-text contact-phone">
            <div class="info-label copy-s">{{ 'PHONE' | translate }}:</div>
            <div class="info-value button-label">
              <a class="btn btn-text" href="tel:{{ phone }}">{{ phone }}</a>
            </div>
          </div>
        }
      </div>
    }
  </address>
  @if (!hideMedia) {
    <div class="card-image-wrapper">
      <div class="card-image-wrapper-inner">
        @if (media) {
          <figure>
            <mb-image class="absolute-positioned" [media]="media" (imageError)="media = undefined"></mb-image>
          </figure>
        }
        @if (!media) {
          <div class="picture-replacement font-family-title">
            <span class="initials">{{ initials }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
